import { useState } from 'react';
import {
  Box,
  ClickAwayListener,
  Link,
  Popper,
  Typography,
} from '@mui/material';

const AdDisclosureMessage: React.FC = () => (
  <Box
    sx={{
      maxWidth: '34em',
      backgroundColor: 'common.white',
      padding: 3,
      border: '1px solid',
      borderColor: 'neutral.light',
      boxShadow: 3,
    }}
  >
    <Typography marginBottom={3} variant="h2" color="primary.main">
      You&rsquo;re our first priority.
      <br />
      Every time.
    </Typography>
    <Typography marginBottom={3}>
      We believe everyone should be able to make financial decisions with
      confidence. And while our site doesn&rsquo;t feature every company or
      financial product available on the market, we&rsquo;re proud that the
      guidance we offer, the information we provide and the tools we create are
      objective, independent, straightforward — and free.
    </Typography>
    <Typography>
      So how do we make money? Our partners compensate us. This may influence
      which products we review and write about (and where those products appear
      on the site), but it in no way affects our recommendations or advice,
      which are grounded in thousands of hours of research. Our partners cannot
      pay us to guarantee favorable reviews of their products or services.{' '}
      <Link href="https://www.nerdwallet.com/blog/our-partners/">
        Here is a list of our partners
      </Link>
      .
    </Typography>
  </Box>
);

const AdDisclosure: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  return (
    <ClickAwayListener
      onClickAway={() => {
        setAnchorEl(null);
      }}
    >
      <div>
        <Link
          aria-describedby="ad-disclosure"
          onClick={handleClick}
          variant="textSmall"
        >
          Advertiser Disclosure
        </Link>
        {/* Setting zIndex to 2 in order to give room for other custom elements
          to have a zIndex of 1 */}
        <Popper open={open} anchorEl={anchorEl} sx={{ zIndex: 2 }}>
          <AdDisclosureMessage />
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
export default AdDisclosure;
